import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function LicenseIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M18.4237 0.974827V6.14963H23.5985L18.4237 0.974827Z" fill="currentColor" />
      <path
        d="M12.9884 12.3903H11.3787L10.8113 14.0923H12.4211L12.9884 12.3903Z"
        fill="currentColor"
      />
      <path
        d="M8.18198 16.8165L7.12135 19.9585C7.05929 20.1423 7.19601 20.3329 7.3901 20.3329H9.16965L10.7025 15.7943H8.25783C8.32557 16.1347 8.27661 16.5167 8.18198 16.8165Z"
        fill="currentColor"
      />
      <path
        d="M9.58459 12.3903H8.58819C8.22192 12.3903 7.89672 12.6246 7.78087 12.9722L7.40746 14.0923H9.0172L9.58459 12.3903Z"
        fill="currentColor"
      />
      <path
        d="M17.5727 7.85162C17.1028 7.85162 16.7217 7.4706 16.7217 7.00063V0.476313H2.82211C2.35213 0.476313 1.97112 0.857332 1.97112 1.32731V28.6727C1.97112 29.1427 2.35213 29.5237 2.82211 29.5237H23.246C23.716 29.5237 24.097 29.1427 24.097 28.6727V7.85162H17.5727ZM6.2261 3.8803H11.3321C12.46 3.92217 12.4591 5.54082 11.3321 5.5823H6.2261C5.09819 5.54043 5.09904 3.92177 6.2261 3.8803ZM6.2261 7.28429H11.3321C12.46 7.32616 12.4591 8.94481 11.3321 8.98629H6.2261C5.09819 8.94442 5.09904 7.32576 6.2261 7.28429ZM19.8421 26.1197H6.2261C5.09819 26.0778 5.09904 24.4592 6.2261 24.4177H19.8421C20.97 24.4596 20.9691 26.0782 19.8421 26.1197ZM19.8421 22.7157H13.6014C12.4735 22.6738 12.4744 21.0552 13.6014 21.0137H19.8421C20.97 21.0556 20.9691 22.6742 19.8421 22.7157ZM20.6931 14.9433C20.6931 15.4132 20.312 15.7943 19.8421 15.7943H16.0703L15.6266 17.3467C15.3152 18.4369 14.3057 19.1983 13.1719 19.1983H11.3493L10.5868 21.4562C10.47 21.8021 10.1456 22.0349 9.78055 22.0349H7.39015C6.03156 22.0349 5.07419 20.7012 5.50882 19.414L6.56974 16.272C6.64893 16.0374 6.47448 15.7943 6.22678 15.7943C5.64595 15.7943 5.23571 15.2252 5.41941 14.6742L6.16613 12.434C6.51363 11.3914 7.48927 10.6883 8.58813 10.6883H19.8421C20.312 10.6883 20.6931 11.0693 20.6931 11.5393V14.9433Z"
        fill="currentColor"
      />
      <path
        d="M11.9242 17.4963H13.1719C13.5499 17.4963 13.8864 17.2424 13.9902 16.8791L14.3001 15.7943H12.499L11.9242 17.4963Z"
        fill="currentColor"
      />
      <path d="M14.2152 14.0923H18.9911V12.3903H14.7825L14.2152 14.0923Z" fill="currentColor" />
    </BaseIcon>
  );
}
